// Body for the Oscar address-delete confirm document: a POST form with the
// confirmation prompt, the address summary, and delete/cancel actions. All
// copy (confirm message, button/link labels) is server-localized so fr_CA is
// preserved; this component only renders the resolved strings.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountContentTitle } from "../AccountContentTitle";
import { SideNav } from "../SideNav";

type IProps = Immutable<templates.AddressDeleteDocumentTemplate> & {
    // The brand button-modifier class for the delete submit. Defaults to the
    // platform value; a site whose legacy address-delete page used a different
    // brand modifier (e.g. toppers' button--ming) overrides it.
    buttonModifierClass?: string;
};

export const AddressDeleteBody = (props: IProps): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        content_title,
        phone_display,
        phone_href,
        action_url,
        confirm_message,
        address_summary,
        delete_label,
        deleting_label,
        or_label,
        cancel_label,
        cancel_url,
        buttonModifierClass = "button--lochmara-blue",
    } = props;
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                <AccountContentTitle
                    contentTitle={content_title}
                    phoneDisplay={phone_display}
                    phoneHref={phone_href}
                />

                <div className="content__copy--full-width">
                    <form method="post" action={action_url}>
                        <CSRFToken />
                        <p>{confirm_message}</p>

                        <p>
                            <strong>{address_summary}</strong>
                        </p>

                        <div className="form-group form-actions">
                            <button
                                type="submit"
                                className={`button ${buttonModifierClass}`}
                                data-loading-text={deleting_label}
                            >
                                {delete_label}
                            </button>{" "}
                            {or_label}{" "}
                            <a
                                className="address-delete-link"
                                href={cancel_url}
                            >
                                {cancel_label}
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
